import SearchParamsBase from "../../../Elements/SearchParamsBase"
import InputTypesEnum from "../../../Enums/InputTypesEnum";

class PricingDetailSearchParams extends SearchParamsBase {
    static saveType = 'PricingDetailSearchParams';
    initialize() {
        this.PricingDetailId = "";
    }

    static fieldsInSearchBox = [
        { fieldName: "PricingDetailId", label: "Pricing Detail Id", className: "col-3", type: InputTypesEnum.Number },

    ]

    static iconName = "fa-solid fa-search";

}
 
export default PricingDetailSearchParams;